module.exports = __webpack_public_path__ + "img/sub_page_communication3.22785fba.png";